export default "__VITE_ASSET__xiMJWcNh__"